import { render, staticRenderFns } from "./Shipping.vue?vue&type=template&id=6b0c1228&scoped=true&"
import script from "./Shipping.vue?vue&type=script&lang=js&"
export * from "./Shipping.vue?vue&type=script&lang=js&"
import style0 from "./Shipping.vue?vue&type=style&index=0&id=6b0c1228&prod&scoped=true&lang=scss&"
import style1 from "./Shipping.vue?vue&type=style&index=1&id=6b0c1228&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0c1228",
  null
  
)

export default component.exports